import { messageDateLabel } from '../../lib/dates';

// The On-duty card's copy-to-clipboard message (Freddi, 2026-07-24) — a count
// and a link, pasted by hand into the staff group chat.
//
// WHY THIS EXISTS, so nobody deletes it as a duplicate: the automated 8am brief
// (apps/api/src/messaging/brief-run.ts) renders a per-staff message and enqueues
// it every morning — but messaging Story 2, the sender that drains that outbox,
// was never built. The jobs sit `queued` and nothing is ever delivered. Until a
// sender exists, this button is the delivery mechanism.
//
// It is deliberately NOT the Messages page's "Dogs Leaving" text: that one lists
// every dog by name for prep, this one is a count plus a pointer into the app.
// Both read messageDateLabel, so they agree on what today is called.
//
// Pure + DOM-free so it unit-tests without a clipboard; the card owns the copy.

// `appUrl` is passed in (the card hands it window.location.origin) rather than
// baked in: a preview deploy then links to itself instead of sending staff to
// production, and there is no host string to rot in the source.
export function buildOnDutyMessage(dateIso: string, leavingCount: number, appUrl: string): string {
  const count =
    leavingCount === 0
      ? 'no dogs leaving today'
      : `${leavingCount} ${leavingCount === 1 ? 'dog' : 'dogs'} leaving today`;

  // The wash instruction only earns its place when there is something to wash;
  // an empty day drops it, and drops "too" with it — there is no today list for
  // tomorrow's to join. Same instinct as the Dogs-Leaving message, which drops
  // its sign-off on an empty day. "they're" reads for one dog or nine.
  const lines = [`${messageDateLabel(dateIso)} — ${count}.`, ''];
  if (leavingCount > 0) lines.push("Please make sure they're washed and brushed.");
  lines.push(`Check the app for tomorrow's list${leavingCount > 0 ? ' too' : ''}:`, appUrl);
  return lines.join('\n');
}
